<template>
  <v-menu left offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <Button v-bind="attrs" size="small" type="ghost" icon="more-horizontal" v-on="on" />
    </template>
    <div class="dropdown-body">
      <DropdownMenuElement @click="$emit('invite')">
        {{ $t('Invite new company') }}
        <template slot="icon">
          <PlusIcon />
        </template>
      </DropdownMenuElement>
      <DropdownMenuElement
        text-class="danger-600"
        @click="$emit(isArchived ? 'unarchive' : 'archive')"
      >
        {{ isArchived ? $t('Unarchive tender') : $t('Archive tender') }}
        <template slot="icon">
          <CloseIcon class="icon-d-600" />
        </template>
      </DropdownMenuElement>
    </div>
  </v-menu>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import PlusIcon from '@/assets/icons/plus.svg';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import CloseIcon from '@/assets/icons/x.svg';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'TenderCardActions',
    components: {
      Button,
      DropdownMenuElement,
      VMenu,
      PlusIcon,
      CloseIcon,
    },
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
    computed: {
      isArchived() {
        return this.tender.status === 'archived';
      },
    },
  };
</script>
